import React from "react";
import { Routes, Route } from "react-router-dom";
import Channel from "./pages/Channel";
import Home from "./pages/Home";
import Player from "./pages/Player";
import Results from "./pages/Results";
import Subscription from "./pages/Subscription";

import "./index.css";
function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/player/:watch" element={<Player />} />
        <Route path="/results/:term" element={<Results />} />
        <Route path="/channel/:channel" element={<Channel />} />
        <Route path="/subscription" element={<Subscription />} />
 
      </Routes>
    </div>
  );
}

export default App;
